import { useEffect, useState } from 'react'
import { setDialogListener } from '../../services/dialogService'
import './Dialog.css'

const DEFAULT_ALERT_TITLE = 'Information'
const DEFAULT_CONFIRM_TITLE = 'Confirm'

function DialogContainer() {
  const [state, setState] = useState(null)

  useEffect(() => {
    setDialogListener((config) => setState(config))
    return () => setDialogListener(null)
  }, [])

  const handleClose = (result) => {
    if (state?.resolve) state.resolve(result)
    setState(null)
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      if (state?.type === 'alert') handleClose()
      else if (state?.type === 'confirm') handleClose(false)
    }
  }

  if (!state) return null

  const isAlert = state.type === 'alert'
  const title = state.title || (isAlert ? DEFAULT_ALERT_TITLE : DEFAULT_CONFIRM_TITLE)

  return (
    <div className="dialog-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true" aria-labelledby="dialog-title" aria-describedby="dialog-message">
      <div className="dialog-box" onClick={(e) => e.stopPropagation()}>
        <h2 id="dialog-title" className="dialog-title">{title}</h2>
        <p id="dialog-message" className="dialog-message">{state.message}</p>
        <div className={`dialog-actions ${isAlert ? 'dialog-actions--single' : ''}`}>
          {isAlert ? (
            <button type="button" className="dialog-btn dialog-btn-primary" onClick={() => handleClose()}>
              OK
            </button>
          ) : (
            <>
              <button type="button" className="dialog-btn dialog-btn-secondary" onClick={() => handleClose(false)}>
                {state.cancelLabel || 'Cancel'}
              </button>
              <button
                type="button"
                className={`dialog-btn ${state.variant === 'danger' ? 'dialog-btn-danger' : 'dialog-btn-primary'}`}
                onClick={() => handleClose(true)}
              >
                {state.confirmLabel || 'Confirm'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default DialogContainer
